import React from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import UsersExchangeForm from '../Forms/UsersExchange.Form'

export default class UsersExchangeModal extends React.Component {
    constructor(props) {
		super(props)
		this.state = { modal: false }
    }

    toggle = () => {
		this.setState(prevState => ({
			modal: !prevState.modal
		}))
    }

    render() {
        const closeBtn = <button className="close" onClick={this.toggle}> &times; </button>
		const label = this.props.buttonLabel
		let button = ''
        let title = ''
        
        if (label === "Edit") {
			button = 
				<Button color="warning"
					onClick={this.toggle}
					style={{ float: "left", marginRight: "10px"}} >
					{label}
				</Button>
				title = "Edit Config Exchange"
		} else {
			button = 
				<Button color="success"
					onClick={this.toggle}
					style={{ float: "left", marginRight: "10px" }}>
						{label}
				</Button>
				title = "Add New Config Exchange"
        }

        return (
            <>
                {button}
                <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle} close={closeBtn}> {title}	</ModalHeader>
                    <ModalBody>
                        <UsersExchangeForm
                            addUsersExchangeToState={this.props.addUsersExchangeToState}
                            updateUsersExchangeState={this.props.updateUsersExchangeState}
                            getUsersExchange={this.props.getUsersExchange}
                            toggle={this.toggle}
                            user_exchange={this.props.user_exchange} />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.toggle}>Submit</Button>
                        <Button color="secondary" onClick={this.toggle}>Batal</Button>
                    </ModalFooter>
                </Modal>
            </>
        )
    }
}